import type {
	Configuration,
	ConfigurationEndpoint,
} from '@/types/configuration';

export const EMPTY_CONFIGURATION: Configuration = {
	jobs: [],
	countries: [],
	nationalities: [],
	degreeLevels: [],
	unavailabilityReasons: [],
	hiringReasons: [],
	documentTypeRefs: [],
	remunerationPeriodicities: [],
	inactivatedReasons: [],
	applicantExperiences: [],
	businessSectors: [],
	rejectedCompanyNeedReasons: [],
	regions: [],
	departments: [],
	jobDurations: [],
	jobIndustries: [],
	jobFunctions: [],
	jobTypes: [],
	jobContracts: [],
	salaryFromOptions: [],
	salaryToOptions: [],
	paRefuseReasons: [],
};

export const CONFIGURATION_API_ENDPOINTS: ConfigurationEndpoint[] = [
	{ key: 'jobs', url: '/ref/jobs' },
	{ key: 'countries', url: '/ref/countries' },
	{ key: 'nationalities', url: '/ref/nationalities' },
	{ key: 'inactivatedReasons', url: '/ref/inactivated-reasons' },
	{
		key: 'degreeLevels',
		url: '/ref/talentplug-referentials/applicant-degrees',
	},
	{ key: 'unavailabilityReasons', url: '/ref/unavailability-reasons' },
	{ key: 'hiringReasons', url: '/ref/hiring-reasons' },
	{
		key: 'remunerationPeriodicities',
		url: '/ref/talentplug-referentials/salary-options',
	},
	{ key: 'documentTypeRefs', url: '/ref/document-type-refs/all' },
	{
		key: 'applicantExperiences',
		url: '/ref/talentplug-referentials/applicant-experiences',
	},
	{ key: 'businessSectors', url: '/ref/business-sectors' },
	{
		key: 'rejectedCompanyNeedReasons',
		url: '/ref/rejected-company-need-reasons',
	},
	{ key: 'regions', url: '/ref/regions' },
	{ key: 'departments', url: '/ref/departments' },
	{ key: 'jobDurations', url: '/ref/talentplug-referentials/job-durations' },
	{ key: 'jobIndustries', url: '/ref/talentplug-referentials/job-industries' },
	{ key: 'jobFunctions', url: '/ref/talentplug-referentials/job-functions' },
	{ key: 'jobTypes', url: '/ref/talentplug-referentials/job-types' },
	{ key: 'jobContracts', url: '/ref/talentplug-referentials/job-contracts' },
	{
		key: 'salaryFromOptions',
		url: '/ref/talentplug-referentials/salary-froms',
	},
	{ key: 'salaryToOptions', url: '/ref/talentplug-referentials/salary-tos' },
	{ key: 'paRefuseReasons', url: '/ref/active-proposal-refuse-reasons' },
];
